// SBW-2273 pricing admin — Redux action types.
// Each CRUD entity has a LIST channel and a MUTATE channel (covers create/update/delete).

// --- Feature Catalog ---
export const FEATURE_CATALOG_LIST_REQUEST = "FEATURE_CATALOG_LIST_REQUEST";
export const FEATURE_CATALOG_LIST_SUCCESS = "FEATURE_CATALOG_LIST_SUCCESS";
export const FEATURE_CATALOG_LIST_FAIL = "FEATURE_CATALOG_LIST_FAIL";
export const FEATURE_CATALOG_MUTATE_REQUEST = "FEATURE_CATALOG_MUTATE_REQUEST";
export const FEATURE_CATALOG_MUTATE_SUCCESS = "FEATURE_CATALOG_MUTATE_SUCCESS";
export const FEATURE_CATALOG_MUTATE_FAIL = "FEATURE_CATALOG_MUTATE_FAIL";

// --- Calculator Presets ---
export const CALCULATOR_PRESET_LIST_REQUEST = "CALCULATOR_PRESET_LIST_REQUEST";
export const CALCULATOR_PRESET_LIST_SUCCESS = "CALCULATOR_PRESET_LIST_SUCCESS";
export const CALCULATOR_PRESET_LIST_FAIL = "CALCULATOR_PRESET_LIST_FAIL";
export const CALCULATOR_PRESET_MUTATE_REQUEST = "CALCULATOR_PRESET_MUTATE_REQUEST";
export const CALCULATOR_PRESET_MUTATE_SUCCESS = "CALCULATOR_PRESET_MUTATE_SUCCESS";
export const CALCULATOR_PRESET_MUTATE_FAIL = "CALCULATOR_PRESET_MUTATE_FAIL";

// --- Top-up Presets ---
export const TOPUP_PRESET_LIST_REQUEST = "TOPUP_PRESET_LIST_REQUEST";
export const TOPUP_PRESET_LIST_SUCCESS = "TOPUP_PRESET_LIST_SUCCESS";
export const TOPUP_PRESET_LIST_FAIL = "TOPUP_PRESET_LIST_FAIL";
export const TOPUP_PRESET_MUTATE_REQUEST = "TOPUP_PRESET_MUTATE_REQUEST";
export const TOPUP_PRESET_MUTATE_SUCCESS = "TOPUP_PRESET_MUTATE_SUCCESS";
export const TOPUP_PRESET_MUTATE_FAIL = "TOPUP_PRESET_MUTATE_FAIL";

// --- Top-up Bonus Rules ---
export const TOPUP_BONUS_RULE_LIST_REQUEST = "TOPUP_BONUS_RULE_LIST_REQUEST";
export const TOPUP_BONUS_RULE_LIST_SUCCESS = "TOPUP_BONUS_RULE_LIST_SUCCESS";
export const TOPUP_BONUS_RULE_LIST_FAIL = "TOPUP_BONUS_RULE_LIST_FAIL";
export const TOPUP_BONUS_RULE_MUTATE_REQUEST = "TOPUP_BONUS_RULE_MUTATE_REQUEST";
export const TOPUP_BONUS_RULE_MUTATE_SUCCESS = "TOPUP_BONUS_RULE_MUTATE_SUCCESS";
export const TOPUP_BONUS_RULE_MUTATE_FAIL = "TOPUP_BONUS_RULE_MUTATE_FAIL";

// --- Currency Credit Rates ---
export const CURRENCY_CREDIT_RATE_LIST_REQUEST = "CURRENCY_CREDIT_RATE_LIST_REQUEST";
export const CURRENCY_CREDIT_RATE_LIST_SUCCESS = "CURRENCY_CREDIT_RATE_LIST_SUCCESS";
export const CURRENCY_CREDIT_RATE_LIST_FAIL = "CURRENCY_CREDIT_RATE_LIST_FAIL";
export const CURRENCY_CREDIT_RATE_MUTATE_REQUEST = "CURRENCY_CREDIT_RATE_MUTATE_REQUEST";
export const CURRENCY_CREDIT_RATE_MUTATE_SUCCESS = "CURRENCY_CREDIT_RATE_MUTATE_SUCCESS";
export const CURRENCY_CREDIT_RATE_MUTATE_FAIL = "CURRENCY_CREDIT_RATE_MUTATE_FAIL";

// --- Charge Sync ---
export const CHARGE_SYNC_PREVIEW_REQUEST = "CHARGE_SYNC_PREVIEW_REQUEST";
export const CHARGE_SYNC_PREVIEW_SUCCESS = "CHARGE_SYNC_PREVIEW_SUCCESS";
export const CHARGE_SYNC_PREVIEW_FAIL = "CHARGE_SYNC_PREVIEW_FAIL";
export const CHARGE_SYNC_APPLY_REQUEST = "CHARGE_SYNC_APPLY_REQUEST";
export const CHARGE_SYNC_APPLY_SUCCESS = "CHARGE_SYNC_APPLY_SUCCESS";
export const CHARGE_SYNC_APPLY_FAIL = "CHARGE_SYNC_APPLY_FAIL";
